import React from 'react';
import { injectIntl } from 'react-intl';
import { Fab, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { tracking } from '../../../utils/tracking';

const SupportFab = ({ intl, openSupportBottomSheet, openSupportDialog }) => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const onClick = () => {
    tracking('Clicked on SupportFab');

    if (isXsScreen) {
      openSupportBottomSheet();
    } else {
      openSupportDialog();
    }
  };

  return (
    <Fab
      className="fab"
      size="medium"
      variant="circular"
      onClick={onClick}
      color="primary"
      style={{
        position: 'fixed',
        zIndex: 10,
        bottom: isXsScreen ? 'calc(62px + var(--bottom-padding))' : 62,
        right: isXsScreen ? 20 : 40,
        width: isXsScreen ? 50 : intl.locale === 'en' ? 160 : 130,
        height: isXsScreen ? 50 : 56,
        borderRadius: isXsScreen ? undefined : 32
      }}
    >
      <img alt="support" src="img/support_icon.svg" />
      {!isXsScreen && (
        <Typography style={{ marginLeft: 12, fontSize: intl.locale === 'en' ? 16 : 18 }}>
          {intl.formatMessage({ id: 'support' })}
        </Typography>
      )}
    </Fab>
  );
};

export default injectIntl(SupportFab);
